/**
 * ROC 7
 * Copyright 2016 ROC Commerce
 * 
 * Any modifications required of core files should be handled in supplemental files 
 * or duplicates of said core files. This is to assist in upgrade paths.
 */

define('modules/Impersonation/Impersonation.Service',[
    'jquery',
    'global/all',
    'plugins/jquery.proxyRequest'
], function ($, Roc) {
    'use strict';

    var apiUrl = window.RocConfig.api.baseRocApiUrl;
    var switchUserUrl = '/switch-user.aspx';

    function loadUserInfo() {
        return $.ajax({
            url: '/ajax/ImpersonationUserInfo',
            type: 'GET',
            dataType: 'json',
            contentType: 'application/json',
            complete: function (xhr) {
                Roc.Logger.info('Impersonation -> loadUserInfo');
                Roc.Logger.info(xhr);
            }
        });
    }

    function searchCarts(request) {
        return $.proxyRequest({
            url: '/api/impersonation/cart-search',
            data: JSON.stringify(request),
            type: 'POST',
            dataType: 'json',
            contentType: 'application/json',
            complete: function (xhr) {
                Roc.Logger.info('Impersonation -> searchCarts');
                Roc.Logger.info(xhr);
            }
        });
    }
    function searchCustomers(request) {
        return $.proxyRequest({
            url: '/api/impersonation/customer-search',
            data: JSON.stringify(request),
            type: 'POST',
            dataType: 'json',
            contentType: 'application/json',
            complete: function (xhr) {
                Roc.Logger.info('Impersonation -> searchCustomers');
                Roc.Logger.info(xhr);
            }
        });
    }

    function impersonateCart(cartId, sessionId, savedCart) {
        savedCart = savedCart || false;

        if (cartId || sessionId) {
            var redirectUrl = switchUserUrl;
            var sep = '?';
            if (cartId) {
                redirectUrl += sep + 'cartId=' + cartId;

                if (savedCart) {
                    redirectUrl += '&isSaved=1';
                }

                sep = '&';
            }
            if (sessionId) {
                redirectUrl += sep + 'sessionId=' + sessionId;
            }

            window.location.href = redirectUrl;
        }
    }

    function impersonateUser(sessionId) {
        var redirectUrl = switchUserUrl + '?sessionId=' + sessionId;
        window.location.href = redirectUrl;
    }

    function impersonateGuest() {
        var redirectUrl = switchUserUrl + '?asGuest=1';
        window.location.href = redirectUrl;
    }

    function stopImpersonating() {
        return $.ajax({
            url: '/ajax/StopImpersonating',
            type: 'POST',
            dataType: 'json',
            contentType: 'application/json',
            complete: function (xhr) {
                Roc.Logger.info('Impersonation -> stopImpersonating');
                Roc.Logger.info(xhr);
            }
        });
    }


    var ImpersonationService = {
        loadUserInfo: loadUserInfo,
        searchCarts: searchCarts,
        searchCustomers: searchCustomers,
        impersonateCart: impersonateCart,
        impersonateUser: impersonateUser,
        impersonateGuest: impersonateGuest,
        stopImpersonating: stopImpersonating,
    };

    Roc.Logger.debug('Impersonation.Service.js Loaded:', ImpersonationService);
    return ImpersonationService;
});
